import React, { Component } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import NoctilSupportCard from './NoctilSupportCard';

class NoctilSupportForRightsManagementOrg extends Component {
  render() {
    return (
      <div className="noctil-support">
        <div className="container">
          <div className="pt--60">
            <div className="row">
              <div className="col-lg-12 text-center">
                <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                  <h2>
                    Noctil supports <br /> Music and Audio-Visual Industry worldwide
                  </h2>
                </ScrollAnimation>
              </div>
              <div className="col-md-6 text-center support-block">
                <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                  <NoctilSupportCard
                    title="Music & AV Rights Organizations"
                    icon={'right-management-supports/music-rights-orgs.png'}
                    listContent={
                      <ul>
                        <li>Works and Repertoire Management</li>
                        <li>Member/Rightsholder </li>
                        <li>Playlist/Playlogs Management </li>
                        <li>Matching</li>
                        <li>Distribution</li>
                        <li>Payment Reports</li>
                        <li>Mandate Management</li>
                        <li>Bilateral Data Exchange</li>
                      </ul>
                    }
                  />
                </ScrollAnimation>
              </div>
              <div className="col-md-6 text-center support-block">
                <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                  <NoctilSupportCard
                    title="Music Publishers"
                    icon={'right-management-supports/music-publishers.png'}
                    listContent={
                      <ul>
                        <li>Works repository management</li>
                        <li>Rightsholder Management</li>
                        <li>Document and Asset Management with tagging</li>
                        <li>Work Registration</li>
                        <li>Distribution</li>
                        <li>Registration Reports and Status</li>
                        <li>Split Calculations</li>
                        <li>Distribution Reports</li>
                      </ul>
                    }
                  />
                </ScrollAnimation>
              </div>
              <div className="col-md-6 text-center support-block">
                <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                  <NoctilSupportCard
                    title="Record labels"
                    icon={'right-management-supports/record-labels.png'}
                    listContent={
                      <ul>
                        <li>Works and Repertoire Management</li>
                        <li>Rightsholders Management</li>
                        <li>Document and Asset Management</li>
                        <li>Work and Repertoire Registration</li>
                        <li>Registration Reports and Status</li>
                        <li>Distribution calculations</li>
                        <li>Payment Reports</li>
                      </ul>
                    }
                  />
                </ScrollAnimation>
              </div>
              <div className="col-md-6 text-center support-block">
                <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                  <NoctilSupportCard
                    title="Administrators"
                    icon={'right-management-supports/administrators.png'}
                    listContent={
                      <ul>
                        <li>Works and Repertoire Management</li>
                        <li>Client/Stakeholder Management</li>
                        <li>Metadata Research</li>
                        <li>Document Management</li>
                        <li>Work and Repertoire Registration</li>
                        <li>Registration Reports and Status</li>
                        <li>Worklist and Assignments</li>
                      </ul>
                    }
                  />
                </ScrollAnimation>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default NoctilSupportForRightsManagementOrg;
